import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import 'leaflet/dist/leaflet.css';
import React, { useEffect } from 'react';
import L from 'leaflet';
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectRallies, selectRalliesStatus } from '../../store/slices/ralliesPreview';
import pinIcon from '../../assets/icons/pin-map.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
// Fix for Leaflet default icon issue with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
const rallyIcon = new L.Icon({
    iconUrl: pinIcon,
    iconSize: [27, 42],
    iconAnchor: [13, 42],
    popupAnchor: [0, -42],
    shadowUrl: markerShadow,
});
const MapBounds = ({ rallies, centerTo }) => {
    const map = useMap();
    useEffect(() => {
        if (centerTo) {
            map.panTo([centerTo.lat, centerTo.lng], { animate: true });
            return;
        }
        if (rallies.length > 0) {
            const bounds = L.latLngBounds([]);
            rallies.forEach(rally => {
                if (rally.latitude && rally.longitude && rally.latitude !== 0 && rally.longitude !== 0) {
                    bounds.extend([rally.latitude, rally.longitude]);
                }
            });
            if (bounds.isValid()) {
                map.fitBounds(bounds, {
                    padding: [25, 25],
                    maxZoom: 13
                });
            }
        }
    }, [map, rallies, centerTo]);
    return null;
};
const RalliesMap = ({ onRallyClick }) => {
    const { t } = useTranslation();
    const rallies = useSelector(selectRallies);
    const ralliesStatus = useSelector(selectRalliesStatus);
    const [centerTo, setCenterTo] = React.useState();
    // Filter rallies to only include those with valid coordinates
    const ralliesWithLocation = rallies.filter(rally => rally.latitude !== null &&
        rally.longitude !== null &&
        rally.latitude !== 0 &&
        rally.longitude !== 0);
    // Default center (will be overridden by MapBounds)
    const defaultCenter = [50.0755, 14.4378]; // Prague
    const handleMarkerClick = (rally) => {
        // Center map to the clicked pin
        setCenterTo({ lat: rally.latitude, lng: rally.longitude });
        onRallyClick(rally.uuid);
    };
    // the list below the map shows the loader or the load error
    if (ralliesStatus !== 'loaded') {
        return null;
    }
    if (ralliesWithLocation.length === 0) {
        return (_jsx("div", { className: "rallies-map no-rallies", children: _jsx("p", { children: t('no_rallies_with_location') }) }));
    }
    return (_jsx("div", { className: "rallies-map", children: _jsxs(MapContainer, { center: defaultCenter, zoom: 10, style: { height: '100%', width: '100%' }, children: [_jsx(TileLayer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' }), _jsx(MapBounds, { rallies: ralliesWithLocation, centerTo: centerTo }), ralliesWithLocation.map((rally) => (_jsx(Marker, { position: [rally.latitude, rally.longitude], icon: rallyIcon, eventHandlers: {
                        click: () => handleMarkerClick(rally),
                    } }, rally.uuid)))] }) }));
};
export default RalliesMap;
